import React from "react";

const Error = () => {
  return <div>Sorry, some error occured!</div>;
};

export default Error;
